import { FormControl, MenuItem, Select } from "@mui/material";
import React, { useState } from "react";
import { Link } from "react-router";
import { CurrencySelector } from "../Common/CurrencySelector";
import { WorldIcon } from "@/Svg/Svg";
import { useTranslation } from "react-i18next";
import Languages from "../Common/Languages";

const TopHeader = () => {
 const {t} = useTranslation()
  return (
    <div
      className={` w-full flex justify-between items-center p-[16px] bg-[#FFFFFF]     `}
    >
      <div className="flex items-center justify-center lg:gap-2 text-sm text-[#6D6C79] font-semibold">
        <Link
          to="/"
          className="text-[var(--Greyscale-900,#0C0A20)] underline
           decoration-[var(--Greyscale-900,#0C0A20)]
           lg:text-[1rem] text-[2vw] decoration-[0.96px] underline-offset-auto"
        >
          {t("Sell on InstaShop")}        </Link>
        {/* <span className="font-black mx-1">&bull;</span> */}

      </div>
      <div className="flex items-center justify-center lg:gap-4">
       <Languages />

        <CurrencySelector />
      </div>
    </div>
  );
};

export default TopHeader;
